<template>
  <div
    v-if="show"
    class="modal-container"
    @click="closeModal()"
  >
    <div
      class="modal-wrapper"
      :style="{ backgroundColor: $store.registratorBackgroundColor }"
    >
      <div class="modal-text-wrapper">
        <p
          class="modal-text"
          :style="{ color: $store.registratorCaptionColor }"
        >
          {{ message }}
        </p>
      </div>
      
      <svg
        class="modal-button-close"
        width="54"
        height="54"
        viewBox="0 0 54 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="closeModal()"
      >
        <path
          d="M27 53.6668C12.272 53.6668 0.333313 41.7282 0.333313 27.0002C0.333313 12.2722 12.272 0.333496 27 0.333496C41.728 0.333496 53.6666 12.2722 53.6666 27.0002C53.6666 41.7282 41.728 53.6668 27 53.6668ZM27 23.2295L19.4586 15.6855L15.6853 19.4588L23.2293 27.0002L15.6853 34.5415L19.4586 38.3148L27 30.7708L34.5413 38.3148L38.3146 34.5415L30.7706 27.0002L38.3146 19.4588L34.5413 15.6855L27 23.2295Z"
          fill="#3C3C43"
          fill-opacity="0.3"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import ModalMixin from '../mixins/ModalMixin';

export default {
  mixins: [ModalMixin],
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/Modal.scss';

.device_mini {
  .modal-wrapper {
    width: 80vw;
    min-height: 50%;
    border-radius: 20px;
  }
}

.modal-wrapper {
  width: 62.5vw;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 33px 38px rgba(0, 0, 0, 0.0314074), 0px 12px 12px rgba(0, 0, 0, 0.05), 0px 3px 3px rgba(0, 0, 0, 0.08);
  border-radius: 20px;
}

.modal-text-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  min-height: 232px;
  flex-grow: 1;

  .modal-text {
    font-weight: 600;
    font-size: 30px;
    text-align: center;
  }
}
</style>
